import { render, staticRenderFns } from "./CrearDescuentos.vue?vue&type=template&id=60039cda&scoped=true"
import script from "./CrearDescuentos.vue?vue&type=script&lang=js"
export * from "./CrearDescuentos.vue?vue&type=script&lang=js"
import style0 from "./CrearDescuentos.vue?vue&type=style&index=0&id=60039cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60039cda",
  null
  
)

export default component.exports